
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kuN8H", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-GB.1f13b416.js.map
